<template>
	<div class="Home-div">
		<div class="global-top">
			<Navbar :activeIndex="activeIndex"></Navbar>
		</div>
		<div class="Home-banner">
      <swiper :options="swiperOption" class="Home-banner-swiper">
          <swiper-slide v-for="(item, index) in swiperimg" :key="index">
            <img :src="item.url" />
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-prev1 swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-next1 swiper-button-white" slot="button-next"></div>
      </swiper>
		</div>
    <div class="Home-content">
      <div class="Home-content-con">
        <div class="Home-con-title">
          <div class="Home-con-title-img"><img src="../assets/images/Home-title.png" /></div>
          <div class="Home-title-more"><router-link class="Home-title-more-link" :to="{path: '/NewLists', query: {articleType: 9, parentMenuId: 2008, menuId: 2012}}">查看更多</router-link></div>
        </div>
        <div class="Home-con-swiper">
          <swiper :options="swiperOption2" class="Home-news-swiper" v-if="articleObj">
            <swiper-slide v-for="(item, index) in articleObj.data" :key="index" class="Home-news-swiperbg">
              <router-link tag="div" :to="`/NewDetail?id=${item.id}`" style="cursor: pointer;">
                <!-- <img class="Home-swiper-img" :src="swiperimg[0].url"/> -->
                <img class="Home-swiper-img" :src="item.pic"/>
                <div class="Home-swiper-con">
                  <div class="Home-swiper-title">{{item.title}}</div>
                  <div class="Home-swiper-content">{{item.introduction}}</div>
                  <div class="Home-swper2-desc">
                    <div class="Home-desc-time">{{item.createTime}}</div>
                    <!-- <div class="Home-desc-from">来自{{item.form}}</div> -->
                  </div>
                </div>
              </router-link>
            </swiper-slide>
            <!-- <div class="swiper-pagination swiper-pagination2" slot="pagination"></div>
            <div class="swiper-button-prev swiper-button-prev2" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-next2" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
    </div>
    <div class="Home-ads">
      <img src="../assets/images/Home-bg2.png"/>
    </div>
	</div>
</template>

<script>
import request from "../util/request";
	import Navbar from "../components/Navbar.vue";

	export default {
		name: "Home",
		components: {
			Navbar,
		},
		data() {
			return {
        activeIndex: 0,
        articleObj: null,
        swiperOption: {
            notNextTick: false,
            pagination: {
                el: '.swiper-pagination1'
            },
            navigation: {
              nextEl: '.swiper-button-next1',
              prevEl: '.swiper-button-prev1'
            },
            loop: true,
            touchRatio: 2, // 触摸滑动的顺畅度
            initialSlide: 1, // 默认展示页
            autoplay: true, // 是否自动播放
            speed: 1500, // 播放速度
            slidesPerView: 'auto',
            centeredSlides: true,
            paginationClickable: true,
            spaceBetween: 5, // 模块之间的间隔
            on: {
                slideChangeTransitionEnd: function() {
                    // 处理手动操作轮播图后后不再自动轮播
                    this.autoplay.start();
                }
            }
        },
        swiperimg: [
          {	id:0,
            url:require("../assets/images/banner@2x.png"),
          },
          {	id:1,
            url:require("../assets/images/banner@2x.png"),
          }
        ], // 轮播图数据
        swiperOption2: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
          loop: true,
          loopFillGroupWithBlank: true,
          pagination: {
            el: '.swiper-pagination2',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next2',
            prevEl: '.swiper-button-prev2'
          }
        },
        msgswiper: [{ // 首页轮播新闻
          id: 0,
          img: require("../assets/images/banner@2x.png"),
          title: "顶峰相见！法国阿根廷会师世界杯",
          content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
          time: "2022-01-01",
          form: "桃子"
        },
        {
          id: 1,
          img: require("../assets/images/banner@2x.png"),
          title: "顶峰相见！法国阿根廷会师世界杯",
          content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
          time: "2022-01-01",
          form: "桃子"
        },
        {
          id: 2,
          img: require("../assets/images/banner@2x.png"),
          title: "顶峰相见！法国阿根廷会师世界杯",
          content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
          time: "2022-01-01",
          form: "桃子"
        },
        {
          id: 3,
          img: require("../assets/images/banner@2x.png"),
          title: "顶峰相见！法国阿根廷会师世界杯",
          content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
          time: "2022-01-01",
          form: "桃子"
        },
        {
          id: 4,
          img: require("../assets/images/banner@2x.png"),
          title: "顶峰相见！法国阿根廷会师世界杯",
          content: "男童被卡淡定吃干脆面等救援 不哭闹终脱困：网友直呼手中有粮一点不慌男童被卡淡定吃干脆面等",
          time: "2022-01-01",
          form: "桃子"
        }]
			}
		},
		computed: {
		},
		mounted() {
      this.getList()
		},
    methods: {
      async getList() {
        let articleObj = await request.get(`/article/list?typeId=9&pageIndex=1&pageSize=3`)
        this.articleObj = articleObj
      },
    }
	}
</script>

<style scoped>
  .Home-banner-swiper {
    height: 500px;
  }
  .Home-ads {
    height: 150px;
  }
  
  .swiper-slide img,
  .Home-ads img{
    height: 100%;
    width: 100%;
  }
  
  ::v-deep .swiper-pagination-bullet-active {
    background-color: #fff;
  }
  
  .Home-content {
    background-image: url("../assets/images/Home-bg1.png");
    background-size: cover;
  }
  
  .Home-content-con {
    width: 1200px;
    margin: 0 auto;
    padding: 55px 0px 45px 0px;
  }
  
  .Home-con-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .Home-title-more {
    border-radius: 5px;
    color: #787878;
    padding: 10px 15px;
    box-sizing: border-box;
    border: 1px solid #787878;
    font-size: 14px;
  }
  
  .Home-title-more-link {
    text-decoration: none;
    color: #787878;
    padding: 10px 15px;
    box-sizing: border-box;
    cursor: pointer;
  }
  
  .Home-con-title-img {
    height: 60px;
  }
  
  .Home-con-title-img img { 
    height: 100%;
  }
  
  .Home-swiper-img {
    height: 158px !important;
  }
  
  .Home-news-swiperbg {
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
  }
  
  .Home-con-swiper {
    margin: 30px auto;
  }
  
  .Home-swiper-img {
    border-radius: 5px;
  }
  
  ::v-deep .swiper-button-prev2,
  ::v-deep .swiper-button-next2 {
    background-color: #fff;
    color: #444;
  }
  
  .Home-swiper-con {
    padding: 12px;
    min-height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .Home-swiper-title {
    color: #262626;
    font-size: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  
  .Home-swiper-content {
    color: #262626;
    font-size: 14px;
    margin-top: 5px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    flex-grow: 2;
  }
  
  .Home-swper2-desc {
    color: #787878;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  .Home-banner,
  .Home-content,
  .Home-ads {
    min-width: 1200px;
  }
</style>
